"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setBillingAddressArgsValidator = exports.createUserSecretsFromArgs = exports.deleteDeviceTokenArgsValidator = exports.deleteDeviceTokenArgsSchema = exports.addDeviceTokenArgsValidator = exports.addDeviceTokenArgsSchema = void 0;
var suretype_1 = require("suretype");
var address_1 = require("../common/address");
// ==========================
// action args
// ==========================
exports.addDeviceTokenArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("addDeviceToken").required(),
    deviceToken: suretype_1.v.string().maxLength(30).required(),
    platform: suretype_1.v.string().enum("browser", "desktop").required()
});
exports.addDeviceTokenArgsValidator = (0, suretype_1.compile)(exports.addDeviceTokenArgsSchema);
exports.deleteDeviceTokenArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("addDeviceToken").required(),
    deviceToken: suretype_1.v.string().maxLength(30).required(),
    platform: suretype_1.v.string().enum("browser", "desktop").required()
});
exports.deleteDeviceTokenArgsValidator = (0, suretype_1.compile)(exports.deleteDeviceTokenArgsSchema);
function createUserSecretsFromArgs(args) {
    return {
        joinedOn: (new Date()).getTime(),
        details: {
            browserDevices: [],
            desktopDevices: [],
            profile: {
                givenName: args.givenName,
                familyName: args.familyName
            },
            memberships: {},
            mutedMemberships: [],
            inboxTimestamp: (new Date()).getTime()
        }
    };
}
exports.createUserSecretsFromArgs = createUserSecretsFromArgs;
var setBillingAddressArgsSchema = suretype_1.v.object({
    address: address_1.addressSchema.required(),
    name: suretype_1.v.string().required()
});
exports.setBillingAddressArgsValidator = (0, suretype_1.compile)(setBillingAddressArgsSchema);
